import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import MissionListPage from './mission-list'
import MissionViewPage from './mission-view'

const missionRoutes: Route[] = [
  {
    path: Paths.MISSION_LIST_PAGE,
    element: <MissionListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.MISSION_LIST_STAFF_PAGE,
    element: <MissionListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.MISSION_VIEW_PAGE,
    element: <MissionViewPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default missionRoutes
